import { isNone, none, Option, some } from 'fp-ts/lib/Option';

export default interface DuplicateDashboardCriteria {
    id: string;
    name: string;
}

class DuplicateDashboardCriteriaImpl implements DuplicateDashboardCriteria {
    constructor(readonly id: string, readonly name: string) {}
}

export class DuplicateDashboardCriteriaBuilder {
    private id: Option<string> = none;

    private name: Option<string> = none;

    static create = (): DuplicateDashboardCriteriaBuilder => new DuplicateDashboardCriteriaBuilder();

    withId = (id: string): DuplicateDashboardCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    withName = (name: string): DuplicateDashboardCriteriaBuilder => {
        this.name = some(name);
        return this;
    };

    build = (): DuplicateDashboardCriteria => {
        if (isNone(this.id) || isNone(this.name)) {
            throw new ReferenceError('Undefined prop');
        }

        return new DuplicateDashboardCriteriaImpl(this.id.value, this.name.value);
    };
}
